import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import ScreenBanner from "../../../../../components/ScreenBanner";
import ListaAcoesRapidas, { TItemAcaoRapida } from "../../../../../components/ListaAcoesRapidas";
import SessaoConfiguracao from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";
import DialogIncluirEditarPraga from "../DialogIncluirEditarPraga";
import PermissionGuard, { usePermission } from "../../../../../components/PermissionGuard";

export default function ListagemPragas() {

    const listaAcoesRapidas: Array<TItemAcaoRapida> = [
        {
            label: `Incluir praga`,
            icon: <AddIcon color="primary" />,
            action: () => handleModalAction("open", true, null),
            havePermission: usePermission("receituario.incluir-praga"),
        }
    ];

    const [openModal, setOpenModal] = useState<TOpenModalPragas>(null);

    const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: IPraga | null) => {
        if (action === "close") setOpenModal(null);
        if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value });
        if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null });
    }, []);

    function RenderListagem() {
        return (
            <SessaoConfiguracao<IPraga>
                titulo="Lista de pragas"
                endpoints={{
                    listar: "/receituario-agronomico/pragas/pesquisar-praga",
                    deletar: "/receituario-agronomico/pragas/excluir-praga",
                }}
                possuiAdicionar={false}
                colunas={colunas}
                queryKey="pesquisar-pragas"
                onEditar={praga => handleModalAction("open", praga.id, praga)}
                onAdicionar={() => handleModalAction("open", true, null)}
                mensagemSucessoDeletar="Praga deletada com sucesso!"
                mensagemErroDeletar="Erro ao deletar praga!"
                mensagemSemDados="Nenhuma praga encontrada."
            />
        );
    }

    return (
        <>
            <ScreenBanner title="Receituário Agronômico" />
            <PermissionGuard permissionId="receituario.listar-pragas">
                <Container sx={{ mt: 3 }}>
                    <Typography textAlign="center" variant="h5">Pragas</Typography>
                    <Grid container spacing={2} mt={1}>
                        <Grid size={{xs: 12, md: 3}}>
                            <ListaAcoesRapidas
                                items={listaAcoesRapidas}
                                fullHeight={false}
                            />
                        </Grid>
                        <Grid size={{xs: 12, md: 9}}>
                            <Box component={Paper}>
                                <Box px={2} pb={2}>
                                    <RenderListagem />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
                {
                    !!openModal &&
                    <DialogIncluirEditarPraga
                        defaultValue={openModal?.defaultValue}
                        open={!!openModal}
                        handleClose={() => handleModalAction("close", true)} />
                }
            </PermissionGuard>

        </>
    );
}

export interface IPraga {
    id: number;
    nome_cientifico: string;
    nome_popular: string;
}

export type TOpenModalPragas = {
    open: number | boolean | null;
    defaultValue: IPraga | null;
} | null;

const colunas = [
    {
        campo: "nome_cientifico" as keyof IPraga,
        titulo: "Nome Científico",
    },
    {
        campo: "nome_popular" as keyof IPraga,
        titulo: "Nome Popular",
    },
];